// submitAnonymousLogin.js
'use strict';
import fetch from '../resource/customFetch.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';
import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';
import handleLoginToken from '../action/handleLoginToken.js';
import fetchAccessToken, { viaTypes } from '../action/fetchAccessToken.js';
import getFpIdPro from '../action/getFpIdPro.js';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { FEATURE_FINGERPRINT_ANONYMOUS_REGISTER } from '../RemoteConfigKeys.js';

import { rejectLogin } from '../resource/loginPromise.js';

/**
 * Submit anonymous login
 * @kind action
 * @return {Promise} Action promise.
 */
const submitAnonymousLogin = () => async (dispatch, getState) => {
  const selectPath = ['submit', 'login', 'anonymous'];

  dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

  try {
    const url = getResourceUrl({ endpoint: '/login/anonymous' });
    const fetchOptions = {
      method: 'POST',
      headers: {
        ...getHeaders(),
      },
    };

    const isFpProEnabled = getRemoteConfigData(
      getState(),
      FEATURE_FINGERPRINT_ANONYMOUS_REGISTER
    );
    if (isFpProEnabled) {
      try {
        await Promise.race([
          dispatch(getFpIdPro({ via: 'user.registered.anonymous' })),
          new Promise((_, reject) => setTimeout(reject, 5000)),
        ]);
        const fpIdPro = getOperationData(
          getState(),
          ['fingerprint'],
          'fpIdPro'
        );
        if (fpIdPro) {
          fetchOptions.headers['X-Fingerprint-Pro-Id'] = fpIdPro;
        }
      } catch {
        // silent fail - don't block anonymous login
      }
    }

    const response = await fetch(url.href, fetchOptions);
    if (!response.ok) {
      await handleFetchError({ response });
    }

    const { refresh_token: refreshToken } = await response.json();

    let token;
    if (refreshToken) {
      await dispatch(
        fetchAccessToken({ refreshToken, via: viaTypes.JWT_LOGIN })
      );
      token = getMeData(getState(), 'token');
    }

    if (!token) {
      throw new Error('Failed to get access token');
    }

    dispatch(handleLoginToken({ token }));
    return dispatch({ type: SET_NETWORKING_SUCCESS, payload: { selectPath } });
  } catch (error) {
    rejectLogin(new Error('login cancelled'));
    return dispatch({
      type: SET_NETWORKING_ERROR,
      payload: { error, selectPath },
    });
  }
};

export default submitAnonymousLogin;
